'use strict';
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('ftSimpleStatusAlert', function() {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          'success': '@',
          'fail': '@',
          'desc': '@',
        },
        templateUrl: 'views/common/simplestatusalert.html',
        link:function link(scope, element, attrs) {
          scope.desc = attrs.desc;
        },
        controller: function($scope) {
          $scope.success = false;
          $scope.fail = false;
        }
      };
    });
})(angular);

